import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseDataService } from './base-data.service';
import { AppConfigService } from './app-config.service';
import { AuthenticationService } from './authentication.service';
import { LoaderService } from './loader.service';
import { AlertsHandlerService } from './alerts-handler.service';

@Injectable({
  providedIn: 'root', 
})
export class ApplicationService extends BaseDataService {
  constructor(
    protected httpClient: HttpClient,
    protected appConfigService: AppConfigService,
    protected authenticationService: AuthenticationService,
    protected loaderService: LoaderService,
    protected alertsHandlerService: AlertsHandlerService
  ) {
    super(httpClient, appConfigService, loaderService, alertsHandlerService);
  }

  public getVersionNumber(): Observable<string> {
    return this.get<string>('application/versionNumber');
  }
}
